let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("ggpBz")).then(() => parcelRequire('WpfYQ'));